import { Link } from 'react-router-dom';

/**
 * The product logo. Links home by default so every page — app, admin, public
 * share/sign screens — offers the same way back; pass `to={null}` where it
 * already sits inside a link.
 */
export default function BrandLogo({ className = 'h-8 w-auto', alt = 'MyDocUploads', to = '/' }) {
  const image = <img src="/mydocuploads-logo-400.png" alt={alt} className={`block object-contain ${className}`} />;
  if (to == null) return image;
  return (
    <Link to={to} aria-label={`${alt} home`} className="inline-flex max-w-full shrink-0">
      {image}
    </Link>
  );
}
